import TextFieldComponent from '../textfield';

class TimeComponent extends TextFieldComponent {
  constructor (component, data, options) {
    super(component, data, options);
  }
}

export default TimeComponent;
